import React from 'react'
import PropTypes from 'prop-types'

import CertListItem from '../CertListItem'

import CertListSkeleton from './CertListSkeleton'

const CertList = ({ certifications }) => {
  return (
    <CertListSkeleton
      certItemsSection={certifications.map((cert, index) => {
        return <CertListItem key={`cert-${index}`} {...cert} />
      })}
    />
  )
}

CertList.propTypes = {
  certifications: PropTypes.array.isRequired,
}

export default CertList
